import { cellEditingFor } from '../rowEditing/rowEditing';
export function isCellValuePresent(row, column) {
    const value = row[column.name];
    if (value == null) return false;
    if (typeof value === 'string') return value !== '';
    if (Array.isArray(value)) return value.length > 0;
    return true;
}
export function columnsByName(columns) {
    return new Map(columns.map((column)=>[
            String(column.name),
            column
        ]));
}
const layoutOf = (spec)=>spec.total === true ? 'spaceBetween' : spec.layout;
const toCardField = (column, spec, isMain, joined)=>({
        column,
        label: spec.label,
        hideColon: !!spec.hideColon,
        inline: !isMain && !!spec.inline,
        layout: layoutOf(spec),
        dividerBefore: !!spec.dividerBefore || !!spec.total,
        // WHY: the main row reads like the desktop main column, and a total like a summary, primary text at main weight on every card.
        emphasis: isMain || spec.total ? 'strong' : spec.emphasis,
        showWhenEmpty: !!spec.showWhenEmpty,
        isMain,
        joined
    });
export function toMobileCardFields(param) {
    let { byName, fields, mainColumn } = param;
    var _fields_find;
    const mainName = mainColumn == null ? undefined : String(mainColumn.name);
    // WHY: the main column always has its own row, so a join that points at it would show it twice.
    const joinedOf = (spec)=>spec.joinWith == null || String(spec.joinWith) === mainName ? undefined : byName.get(String(spec.joinWith));
    const others = fields.flatMap((spec)=>{
        if (String(spec.name) === mainName) return [];
        const column = byName.get(String(spec.name));
        return column == null ? [] : [
            toCardField(column, spec, false, joinedOf(spec))
        ];
    });
    if (mainColumn == null) return others;
    // WHY: every card leads with the record it is, so a field list that omits the main column still gets it.
    const mainSpec = (_fields_find = fields.find((spec)=>String(spec.name) === mainName)) !== null && _fields_find !== void 0 ? _fields_find : {
        name: mainColumn.name
    };
    return [
        toCardField(mainColumn, mainSpec, true, joinedOf(mainSpec)),
        ...others
    ];
}
export const columnName = (column)=>String(column.name);
// WHY: a phone card flips a switch, as the pre-flag cards did; every other cell only reads there.
export const cardCellEditing = (editing, column)=>column.type === 'toggle' ? cellEditingFor(editing, columnName(column)) : undefined;
export const subtitleOf = (column, row)=>{
    var _ref;
    var _column_subtitle;
    return column.type === 'text' ? ((_ref = (_column_subtitle = column.subtitle) === null || _column_subtitle === void 0 ? void 0 : _column_subtitle.call(column, row)) !== null && _ref !== void 0 ? _ref : []).filter((line)=>line !== '') : [];
};
// WHY: a card moves a text main column's subtitle to its own line so inline fields sit right after the main value; any other cell keeps its own second line.
export const movesSubtitleOut = (field)=>field.isMain && field.column.type === 'text';
export const isShown = (field, row)=>field.isMain || field.showWhenEmpty || isCellValuePresent(row, field.column) || field.joined != null && isCellValuePresent(row, field.joined);
// WHY: a joined row keeps the label with the first value, so an empty first value drops both and the joined value stands alone.
export const showsOwnValue = (field, row)=>field.joined == null || field.showWhenEmpty || isCellValuePresent(row, field.column);
// WHY: the badge stands in for missing actions, and a badge or end-of-row control with no value leaves the action area alone.
export const cardActionsContent = (param)=>{
    let { row, rowActions, badgeColumn, trailingColumn } = param;
    return {
        actions: rowActions,
        badge: rowActions == null && badgeColumn != null && isCellValuePresent(row, badgeColumn) ? badgeColumn : undefined,
        trailing: trailingColumn != null && isCellValuePresent(row, trailingColumn) ? trailingColumn : undefined
    };
};
export const hasCardActionsContent = (content)=>content.actions != null || content.badge != null || content.trailing != null;
